var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.7517C10.5553 12.9133 11.1425 13 11.75 13C12.7358 13 13.6683 12.7718 14.4976 12.3652C14.4992 12.327 14.5 12.2886 14.5 12.25C14.5 10.7312 13.2688 9.5 11.75 9.5C10.8046 9.5 9.97068 9.97701 9.47572 10.7035M10 12.7517V12.75C10 12.0081 9.80989 11.3105 9.47572 10.7035M10 12.7517C9.99999 12.7755 9.99978 12.7992 9.99939 12.8229C8.75824 13.5702 7.30432 14 5.75 14C4.19568 14 2.74176 13.5702 1.50061 12.8229C1.50021 12.7986 1.5 12.7743 1.5 12.75C1.5 10.4028 3.40279 8.5 5.75 8.5C7.35528 8.5 8.75269 9.38999 9.47572 10.7035M8 4.25C8 5.49264 6.99264 6.5 5.75 6.5C4.50736 6.5 3.5 5.49264 3.5 4.25C3.5 3.00736 4.50736 2 5.75 2C6.99264 2 8 3.00736 8 4.25ZM13.5 5.75C13.5 6.7165 12.7165 7.5 11.75 7.5C10.7835 7.5 10 6.7165 10 5.75C10 4.7835 10.7835 4 11.75 4C12.7165 4 13.5 4.7835 13.5 5.75Z",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUserIcon);
export default __webpack_public_path__ + "static/media/total-user-icon.3bb7584d3e9a660d1433dfd1f7283964.svg";
export { ForwardRef as ReactComponent };